import React from 'react';
import ReactDOM from 'react-dom';
import { useAppSelector } from '../../store/hooks';
import styles from './loader.module.scss';

const Loader: React.FC = () => {
  const { isLoading, isLoadingSmall, loadingText } = useAppSelector((state) => state.ui);

  if (!isLoading && !isLoadingSmall) return null;

  if (isLoadingSmall && !isLoading) {
    return ReactDOM.createPortal(
      <div className={styles.smallWrapper}>
        <div className={styles.spinner}></div>
      </div>,
      document.body,
    );
  }

  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.spinner}></div>
      {/* {loadingText && <div className={styles.text}>{loadingText}</div>} */}
    </div>,
    document.body,
  );
};

export default Loader;
